import PrimeVue from 'primevue/config'
import TreeSelect from 'primevue/treeselect'
import ContextMenu from 'primevue/contextmenu';
import Menu from 'primevue/menu';

import Aura from '@primeuix/themes/aura'

//import 'primeicons/primeicons.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false
      }
    }
  })
  nuxtApp.vueApp.component('TreeSelect', TreeSelect)
  nuxtApp.vueApp.component('ContextMenu', ContextMenu)
  nuxtApp.vueApp.component('Menu', Menu)
})
